if (!customElements.get('transformations-carousel')) {
  class TransformationsCarousel extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('.flickity-button-custom').forEach((button) => {
        button.addEventListener('click', this.handlePrevNextClick.bind(this));
      });
    }

    handlePrevNextClick(event) {
      const slider = this.querySelector('[data-flickity]');
      const sliderFlickity = Flickity.data(slider);
      console.log(sliderFlickity);
      const button = event.currentTarget;
      const direction = button.classList.contains('previous') ? 'previous' : 'next';
      sliderFlickity[direction]();
    }
  }

  // intiat transformations-carousel custom element
  customElements.define('transformations-carousel', TransformationsCarousel);
}
